import networkAutomation from "public/pocCloud/network-automation.png";

export const INTRO_CONSTANTS = {
  title: "Effortless Automation for Complex Network Environments ",
  description: [
    "Modern networks demand speed, reliability, and intelligent management. OneMind’s Network Automation solutions enable organizations to automate the configuration, deployment, and operation of both physical and virtual network environments—reducing manual effort and driving operational excellence.",
    "By eliminating repetitive tasks and human error, automation increases agility, enhances security, and ensures consistent policy enforcement across complex infrastructures.",
  ],
  points: [
    "Self-Healing & Auto-Scaling Networks : Deploy dynamic, fault-tolerant configurations that adapt in real time.",
    "AI-Powered Traffic Optimization : Leverage intelligent monitoring to analyze performance and optimize traffic flows.",
    "Automated Security & Compliance : Enforce policies, updates, and access controls across your network—automatically.",
  ],
  image: networkAutomation,
};
